import { useSettings } from '../../hooks/queries'
import { Stand } from './DiensteCard'

/**
 * Ob GIFs in Antworten zur Verfügung stehen — und was zu tun ist, wenn nicht.
 *
 * **Der Grund für diese Karte ist eine Meldung aus dem Betrieb:** „kein Knopf
 * um GIFs hochzuladen". Ohne `GIPHY_API_KEY` steht in der Eingabezeile
 * nichts, und das ist so gewollt — aber wer es nicht weiß, sucht einen Knopf,
 * den es nicht gibt. Ein abgeschalteter Dienst muss sagen, dass er
 * abgeschaltet ist; sonst sieht Absicht aus wie ein Fehler.
 *
 * Sie steht neben „Ort und Wetter" und nicht darin: das ist ein anderer
 * Dienst mit einem anderen Schlüssel.
 */
export function GifCard() {
  const settings = useSettings()
  const daten = settings.data

  // Ohne Decke ist dieses Konto keine Verwaltung -- der Server hat entschieden.
  if (!daten?.ceiling) return null

  const an = daten.services?.gif === true

  return (
    <div className="card card--seite">
      <h2 className="card__titel">GIFs in Antworten</h2>
      <p className="card__lead" style={{ marginBottom: 10 }}>
        Womit ein Mitlesender auf einen Beitrag antwortet, wenn Worte nicht
        der Ton sind.
      </p>

      <p className="dienst">
        <span className="dienst__name">GIF-Auswahl</span>
        <Stand an={an} />
      </p>

      {an ? (
        <p className="card__lead" style={{ marginTop: 10, marginBottom: 0 }}>
          Der GIF-Knopf steht in der Eingabezeile. Gesucht wird über den
          Server — dorthin geht der Suchbegriff, nicht die Adresse des
          Lesers. Das gewählte GIF holt der Server einmal und legt es ab wie
          ein hochgeladenes Bild; beim Ansehen geht danach nichts mehr
          hinaus. Es zählt dafür gegen das Kontingent der Reise.
        </p>
      ) : (
        <>
          <p className="card__lead" style={{ marginTop: 10, marginBottom: 0 }}>
            Das ist in Ordnung: ohne diese Angabe läuft alles weiter, es gibt
            dann nur keinen GIF-Knopf und Mitlesende antworten mit Worten.
            Wer sie einrichten möchte, holt sich auf{' '}
            <code>developers.giphy.com</code> einen kostenlosen Schlüssel
            („Create an App" → <strong>API</strong>, nicht SDK) und trägt ihn
            in die <code>.env</code> auf dem Server ein:
          </p>
          <ul className="dienst__zeilen">
            <li>GIPHY_API_KEY</li>
          </ul>
        </>
      )}
    </div>
  )
}
